<script>
import "./signinCss";
import moment from "moment";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { signinStore } from "@signin/signinStore";
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlStore, createStoreIndex } from "@common/control/controlStore";
import messagePanel from "@common/messagePanel";
import { mapState } from "vuex";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));
let timeouts = {};

let signInOutConfig = {
    cId: "signInOut",
    cType: "signInOut",
    cTitle: "Sign In/Out",
    cTemplate: `<div class="sign-in-out container signin-css" :id="cId + '_signInOutWrapper'">
                    <div class="col-sm-10 col-md-10 pb20 m0a">
                        <control name="SIS_LOGO"></control>
                    </div>
                    <div class="col-sm-10 col-md-10 pb20 station-pane m0a">
                        <div>
                            <h1 class="ac mb0 mt10"><control name="SIS_NAME"></control></h1>
                        </div>
                        <div v-show="!stationConfigured">
                            <control name="STATION_NOT_CONFIGURED_BY_GEO_MESSAGE"></control>
                        </div>
                        <div v-show="stationConfigured">
                            <hr/>
                            <div class="ready-to-signout-message" v-show="controlValue('SIGNED_IN') == true">
                                <div>
                                    {{ ddStoreFilter('DD.SIGNIN2_OPTIONS.READY_TO_SIGN_OUT_QUESTION') }}
                                </div>
                            </div>
                            <div class="ac mb10 fwb textxl">
                                <div class="inline-block">Hello, {{controlValue('VOL_FIRST_NAME')}} {{controlValue('VOL_LAST_NAME')}}</div>
                            </div>
                            <div v-if="showVolunteerMessages">
                                <message-panel :c-id="'messagePanel_signinVolunteerMessages'" ref="signinVolunteerMessages"></message-panel>
                            </div>
                            <div v-show="controlValue('SIGNED_IN') == true && controlValue('ACTION_CANCELED')">
                                 <control name="CURRENT_TIME"></control>
                            </div>
                            <div class="textxl">
                                <div v-show="controlValue('ERROR')">
                                        <control name="ERROR"></control>
                                </div>
                                <div v-if="showSurvey && !signOutError">
                                    <div v-if="!surveySubmited">
                                        <control name="SURVEY_SIGN_OUT_INFO_MESSAGE"></control>
                                    </div>
                                    <div v-if="surveySubmited">
                                        <control name="SURVEY_SIGN_OUT_SURVEY_INFO_MESSAGE"></control>
                                    </div>
                                </div>
                                <div v-if="!showSurvey" v-show="controlValue('INFO') && !controlValue('SUCCESS')">
                                    <control name="INFO"></control>
                                </div>
                                <div v-if="seconds && controlValue('SUCCESS')" class="alert alert-success ac mt20 e-block">{{ ddStoreFilter(controlValue('SUCCESS')) }} You will be redirected to the main screen in {{seconds}} seconds.</div>
                            </div>
                            <div v-show="controlValue('SIGNED_IN') == false">
                                <div v-show="controlValue('ACTION_CANCELED')">
                                    <div>
                                        <control name="VOL_OPPORTUNITY_LIST" :items="volOppList"></control>
                                    </div>
                                    <div>
                                        <control name="VOL_SLOT_LIST" :items="volSlotList"></control>
                                    </div>
                                </div>
                                <hr/>
                                <div v-show="controlValue('ACTION_CANCELED') || showBackButtonInsteadOfUndo">
                                    <control name="BACK_BUTTON"></control>
                                </div>
                            </div>
                            <div v-show="controlValue('SIGNED_IN') == true">
                                <div v-show="controlValue('ACTION_CANCELED')">
                                    <div v-if="showSurvey && !surveySubmited">
                                        <control name="TAKE_SURVEY_BUTTON"></control>
                                    </div>
                                    <div>
                                        <control name="SIGN_OUT_BUTTON" :disabled="showSurvey && !surveySubmited"></control>
                                    </div>
                                </div>
                                <hr/>
                                <div v-show="controlValue('ACTION_CANCELED')" >
                                    <control name="BACK_BUTTON"></control>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'VOL_FIRST_NAME',
            asField: true,
            type: "string",
        },
        {
            name: 'VOL_LAST_NAME',
            asField: true,
            type: "string",
        },
        {
            name: 'CURRENT_TIME',
            asField: true,
            type: "date",
            format: "LTS"
        },
        {
            name: 'BACK_BUTTON',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.BACK_BUTTON",
            onclick: "goToLogin",
            text: true,
            cssClass: "e-back e-link"
        },
        {
            name: 'VOL_OPPORTUNITY_LIST',
            type: "list",
            label: "Opportunities",
            itemContentTemplate: "<div class=\"col-xs-5 col-sm-6 col-md-7 fl\" :data-test-id=\"dataTestId+'_'+data.key\">"
                    + "        <div class=\"list-item-title\">{{data.OPP_TITLE}}</div>"
                    + "     </div>"
                    + "     <div class=\"col-xs-7 col-sm-6 col-md-5 pt0 fl\">"
                    + "            <div class=\"col-xs-6 col-sm-6 col-md-6 fr\">"
                    + "                <control :name=\"'SIGN_IN_BUTTON'+''\" :actionParams=\"data\"></control>"
                    + "            </div>"
                    + "     </div>"
        },
        {
            name: 'VOL_SLOT_LIST',
            "type": "list",
            "label": "Schedule Shifts",
            itemContentTemplate: "<div class=\"col-xs-12 col-sm-12 col-md-7 fl\" :data-test-id=\"dataTestId+'_'+data.key\">"
                    + "        <div class=\"list-item-title\">{{data.OPP_TITLE}} : {{data.SS_START_TIME}} - {{data.SS_FINISH_TIME}}</div>"
                    + "     </div>"
                    + "     <div class=\"col-xs-12 col-sm-12 col-md-5 fl pt0\">"
                    + "            <div class=\"col-xs-6 col-sm-6 col-md-6 fl pt0\" v-show=\"controlValue('SIS_HIDE_GROUP_SIGNIN') == 0 && !data.TIME_LOGGED\">"
                    + "                <div v-show=\"data.show_group_size == 0 && !data.SLOT_SIGNED_IN\">"
                    + "                    <control :name=\"'SHOW_GROUP_SIZE'+''\" :actionParams=\"data\"></control>"
                    + "                </div>"
                    + "                <div v-show=\"data.show_group_size == 1\">"
                    + "                     <control :name=\"'GROUP_SIZE__'+data.key\" :actionParams=\"data\"></control>"
                    + "                </div>"
                    + "            </div>"
                    + "            <div class=\"col-xs-6 col-sm-6 col-md-6 fr pt0\" v-show=\"!data.TIME_LOGGED\">"
                    + "                <control :name=\"'SIGN_IN_BUTTON__'+data.key\" :actionParams=\"data\"></control>"
                    + "            </div>"
                    + "     </div>"
                    + "     <div class='clearfix'></div>"
        },
        {
            name: 'UNDO_SIGNIN_BUTTON',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.UNDO_SIGNIN_BUTTON",
            onclick: "signInCancel",
            text: true,
            cssClass: "e-link"
        },
        {
            name: 'UNDO_SIGNOUT_BUTTON',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.UNDO_SIGNOUT_BUTTON",
            onclick: "signOutCancel",
            text: true,
            cssClass: "e-link"
        },
        {
            name: 'SIS_HIDE_GROUP_SIGNIN',
            asField: true,
            type: "boolean",
            default: false
        },
        {
            name: 'SIGN_IN_BUTTON',
            type: "button",
            label: "Sign In",
            onclick: "signIn",
            cssClass: "e-success"
        },
        {
            name: 'TAKE_SURVEY_BUTTON',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.TAKE_SURVEY_BUTTON",
            onclick: "takeSurvey",
            cssClass: "e-yellow"
        },
        {
            name: 'SIGN_OUT_BUTTON',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.SIGN_OUT_BUTTON",
            onclick: "signOut",
            cssClass: "e-danger"
        },
        {
            name: 'SHOW_GROUP_SIZE',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.SHOW_GROUP_SIZE",
            onclick: "showGroupSize",
            text: true,
            cssClass: "e-link"
        },
        {
            name: 'GROUP_SIZE',
            type: "number",
            onchange: "changeGroupSize",
            min: 1,
            max: 999,
            format: "###"
        },
        {
            name: 'SIS_LOGO',
            type: "image",
            cssClass: "sis-logo col-xs-4 col-sm-4 col-md-4"
        },
        {
            name: 'SIS_NAME',
            asField: true,
            type: "string",
            value: "Sign-In Station"
        },
        {
            name: 'ERROR',
            asField: true,
            type: "error",
            value: ""
        },
        {
            name: 'SURVEY_SIGN_OUT_INFO_MESSAGE',
            asField: true,
            type: "info",
            value: "DD.SIGNIN2_OPTIONS.SURVEY_SIGN_OUT_INFO_MESSAGE"
        },
        {
            name: 'SURVEY_SIGN_OUT_SURVEY_INFO_MESSAGE',
            asField: true,
            type: "info",
            value: ""
        },
        {
            name: 'INFO',
            asField: true,
            type: "info",
            value: ""
        },
        {
            name: 'SUCCESS',
            asField: true,
            type: "success",
            value: ""
        },
        {
            name: 'SIGNIN_MESSAGES',
            asField: true,
            type: "success",
            value: ""
        },
        {
            name: 'ACTION_CANCELED',
            asField: true,
            type: "boolean",
            value: true
        },
        {
            name: 'IS_GUEST',
            asField: true,
            type: "boolean",
            value: false
        },
        {
            name: 'SIGN_OUT',
            asField: true,
            type: "boolean",
            value: false
        },
        {
            name: 'SIGNED_IN',
            asField: true,
            type: "boolean",
            value: false
        },
        {
            name: 'SIGNIN_COMPLETE_MESSAGE',
            asField: true,
            value: "DD.SIGNIN2_OPTIONS.SIGNIN_COMPLETE_MESSAGE",
            type: "success"
        },
        {
            name: 'SIGNIN_CANCELED_MESSAGE',
            asField: true,
            value: "DD.SIGNIN2_OPTIONS.SIGNIN_CANCELED_MESSAGE",
            type: "error"
        },
        {
            name: 'SIGNOUT_CANCELED_MESSAGE',
            asField: true,
            value: "DD.SIGNIN2_OPTIONS.SIGNOUT_CANCELED_MESSAGE",
            type: "error"
        },
        {
            name: 'SIGNOUT_COMPLETE_MESSAGE',
            asField: true,
            value: "DD.SIGNIN2_OPTIONS.SIGNOUT_COMPLETE_MESSAGE",
            type: "success"
        },
        {
            name: 'SELECT_OPP_FOR_SIGNIN_MESSAGE',
            asField: true,
            value: "DD.SIGNIN2_OPTIONS.SELECT_OPP_FOR_SIGNIN_MESSAGE",
            type: "info"
        },
        {
            name: 'SELECT_SHIFT_FOR_SIGNIN_MESSAGE',
            asField: true,
            value: "DD.SIGNIN2_OPTIONS.SELECT_SHIFT_FOR_SIGNIN_MESSAGE",
            type: "info"
        },
        {
            name: 'SURVEY_LIST',
            value: "Please select from the following survey(s):",
            type: "dropdown",
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'STATION_NOT_CONFIGURED_BY_GEO_MESSAGE',
            asField: true,
            value: "The location of your device is out of range for this station. Please contact your volunteer coordinator for more information.",
            type: "info"
        },
    ],
    layoutDatamap: [
        {
            "property": "volunteerLoggedIn", "from": "signInOut", "to": "thisStore", "as": "volunteerLoggedIn"
        }
    ]
};

let signInOutCmp = {
    name: 'signInOut',
    preInitControls: true,
    props: {
        staticId: {
            default: true
        }
    },
    data: function () {
        return {
            volunteerLoggedIn: true,
            volSlotList: [],
            volOppList: [],
            lastAction: false,
            volunteerId: false,
            signOutLbe: false,
            seconds: 0,
            showVolunteerMessages: false,
            surveySubmited: false,
            showBackButtonInsteadOfUndo: false,
            signOutError: false,
            userActions: [],
            signInButtonClicked: true,
        };
    },
    computed: {
        ...mapState('signinStore', ['isConfigured']),
        signinStore() {
            return signinStore.state;
        },
        stationConfigured() {
            return this.isConfigured;
        },
        stationId() {
            return signinStore.state.stationId;
        },
        loginData() {
            return signinStore.state.volunteer;
        },
        volunteer() {
            return signinStore.state.volunteer.volFields;
        },
        showSurvey() {
            return !!(this.signOutLbe
                && this.controls
                && this.controls['SIS_ENABLE_ADD_SURVEY_PROMPT']
                && parseInt(this.controls['SIS_ENABLE_ADD_SURVEY_PROMPT'].value, 10) === 2
                && typeof this.controls['SURVEY_LIST'] !== 'undefined'
                && this.controls['SURVEY_LIST'].items
                && this.controls['SURVEY_LIST'].items.length);
        }
    },
    methods: {
        async onLoad() {
            this.signInButtonClicked = false;
            if (this.stationConfigured) {
                let controls = Object.values(this.signinStore.controls);
                controls.forEach((control) => {
                    if (this.controlConfigs[control.name]) control = { ...this.controlConfigs[control.name], ...control };
                    let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                    controlStore().addControl(control, this, controlStoreIndex);
                });
                if (!this.controls['SIS_LOGO'].value) this.controls['SIS_LOGO'].value = this.signinStore.controls['SIS_LOGO'].value;
                this.parseVolData();
                if (this.accountSettings && typeof this.accountSettings['ACCOUNT_TIME_ZONE'] !== 'undefined' && (typeof this.accountSettings['SIO_TIMEZONE_BROWSER'] === 'undefined' || this.accountSettings['SIO_TIMEZONE_BROWSER'] !== '1')) {
                    let accountTz = parseInt(this.accountSettings['ACCOUNT_TIME_ZONE'], 10);
                    if (accountTz) {
                        accountTz *= 60; // NOSONAR
                        let localTz = moment().utcOffset();
                        this.controls['CURRENT_TIME'].addMinutes = accountTz - localTz;
                    }
                }
                this.goToLoginWaitSec = this.signinStore.controls['SIS_SUPERVISIOR_TIMEOUT'].value;
                this.startGoToLoginTimeout();
                document.addEventListener("click", this.onClick, true);
                document.addEventListener("keydown", this.onClick, true);
                document.addEventListener('mousedown', this.onClick, true);
                document.addEventListener('touchstart', this.onClick, true);
            }
        },
        onClick: function (e) {
            // log user actions
            let getElId = function (el) {
                return el.id || el?.closest('[id]')?.id;
            };
            try {
                if (e && e.target && getElId(e.target)) this.userActions.push({ type: e.type, target: getElId(e.target) });
            } catch (er) {
                // do nothing
            }
            this.startGoToLoginTimeout();
        },
        stopGoToLoginTimeout: function () {
            if (!this.cId || !this || this === null) return;
            if (typeof timeouts?.["goToLogin"] !== "undefined") {
                clearTimeout(timeouts["goToLogin"]);
            }
        },
        startGoToLoginTimeout: function () {
            if (!this.cId || !this || this === null) return;
            let goToLoginWaitSec = parseInt(this.goToLoginWaitSec, 10) || 0; // 0 - not use auto logout
            if (isNaN(goToLoginWaitSec) || goToLoginWaitSec < 1) return;
            if (typeof timeouts === 'undefined') timeouts = {};
            if (typeof timeouts["goToLogin"] !== "undefined") {
                clearTimeout(timeouts["goToLogin"]);
            }
            timeouts["goToLogin"] = setTimeout(() => {
                this.goToLogin('auto');
            }, goToLoginWaitSec * 1000); // NOSONAR
        },
        removeHandlers() {
            document.removeEventListener("click", this.onClick, true);
            document.removeEventListener("keydown", this.onClick, true);
            document.removeEventListener('mousedown', this.onClick, true);
            document.removeEventListener('touchstart', this.onClick, true);
        },
        clearTimeouts() {
            for (let i in timeouts) {
                if (i === 'length') continue;
                clearTimeout(timeouts[i]);
                timeouts[i] = 0;
            }
        },
        goToLogin: async function (type) {
            this.removeHandlers();
            this.clearTimeouts();
            signinStore.set('isGuest', false);
            signinStore.set('volunteer', false);
            library.hideAllDialogs();
            if (type !== 'auto') type = 'manual';
            await this.sDs.post('er_logOut', 'vol', false, type);
            this.volunteerLoggedIn = false;
        },
        parseVolData: async function () {
            if (this.loginData) {
                let dataFields = this.loginData.volFields;
                let dataOpps = this.loginData.volOpps;
                let dataSlots = this.loginData.volSlots;
                let dataSurveys = this.loginData.volSurveys;
                let signinMessages = this.loginData.signinMessages;
                this.showVolunteerMessages = false;
                if (Array.isArray(signinMessages) && signinMessages.length) {
                    let messages = [];
                    for (let i in signinMessages) {
                        if (i === 'length') continue;
                        let text = '<div>' + signinMessages[i].subject + '</div>' + signinMessages[i].message;
                        text = text.replace(/\n/i, '<br>');
                        while (text.endsWith("<br/>") || text.endsWith("<br>")) {
                            text = text.replace(/<br\/>|<br>+$/, '');
                        }
                        messages.push({
                            text: text,
                            dismissible: true
                        });
                    }
                    if (messages.length) {
                        this.showVolunteerMessages = true;
                        this.$nextTick(() => {
                            if (this && this.$refs && this.$refs['signinVolunteerMessages'] && this.$refs['signinVolunteerMessages']) {
                                this.$refs['signinVolunteerMessages'].messages = library.cloneObj(messages);
                            }
                        });
                    }
                }
                if (dataFields) {
                    let volunteerId = library.cloneObj(dataFields["ID"]);
                    let volunteer = library.cloneObj(dataFields);
                    this.volunteerId = volunteerId;
                    if (typeof this.loginData.signOutLbe !== 'undefined' && parseInt(this.loginData.signOutLbe, 10) > 0) {
                        this.signOutLbe = this.loginData.signOutLbe;
                    } else {
                        this.signOutLbe = false;
                    }
                    this.controls['SURVEY_SIGN_OUT_SURVEY_INFO_MESSAGE'].value = '';
                    if (typeof this.loginData.signOutDPTitle !== 'undefined' && this.loginData.signOutDPTitle) {
                        this.surveySubmited = true;
                        this.controls['SURVEY_SIGN_OUT_SURVEY_INFO_MESSAGE'].value = "Sign out of the " + (this && this.volunteer && this.volunteer.VOL_SIGNIN_SLOT !== "" ? "shift" : "opportunity") + " " + (this && this.volunteer ? this.volunteer.VOL_SIGNIN_OPP : '') + ".";
                    }
                    let tmpControls = {};
                    for (let i in dataFields) {
                        if (i === 'length') continue;
                        if (typeof (tmpControls[i]) === "undefined") tmpControls[i] = {};
                        tmpControls[i].type = "string";
                        tmpControls[i].name = i;
                        tmpControls[i].asField = true;
                        if (Array.isArray(dataFields[i])) {
                            tmpControls[i].value = dataFields[i].join();
                        } else {
                            tmpControls[i].value = dataFields[i];
                        }
                    }
                    Object.values(tmpControls).forEach((control) => {
                        let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                        controlStore().addControl(control, this, controlStoreIndex);
                    });

                    let tmpVolSlots = [];
                    let tmpVolOpps = [];
                    this.volSlotList = [];
                    this.volOppList = [];
                    for (let i in dataSlots) {
                        if (i === 'length') continue;
                        dataSlots[i].group_size = parseInt(dataSlots[i].GROUPSIZE, 10) || 1;
                        dataSlots[i].show_group_size = 0;
                        if (dataSlots[i].ID) {
                            dataSlots[i].SCHEDULE_SLOT_ID = dataSlots[i].ID;
                            delete dataSlots[i].ID;
                        }
                        tmpVolSlots.push(dataSlots[i]);
                    }
                    if (tmpVolSlots.length) {
                        let listControls = [];
                        let groupSize = {};
                        let signinButton = {};
                        for (let i in tmpVolSlots) {
                            if (i === 'length') continue;
                            groupSize = library.cloneObj(this.controls['GROUP_SIZE']);
                            groupSize.name = 'GROUP_SIZE__' + i;
                            groupSize.value = 0;
                            listControls.push(groupSize);
                            signinButton = library.cloneObj(this.controls['SIGN_IN_BUTTON']);
                            signinButton.name = 'SIGN_IN_BUTTON__' + i;
                            if (tmpVolSlots[i].group_size > 1) {
                                signinButton.label = "Sign In with " + tmpVolSlots[i].group_size;
                            } else {
                                signinButton.label = "Sign In";
                            }
                            listControls.push(signinButton);
                        }
                        Object.values(tmpControls).forEach((control) => {
                            let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                            controlStore().addControl(control, this, controlStoreIndex);
                        });
                        this.volSlotList = tmpVolSlots;
                    } else {
                        for (let i in dataOpps) {
                            if (i === 'length') continue;
                            dataOpps[i].group_size = 1;
                            dataOpps[i].show_group_size = 0;
                            tmpVolOpps.push(dataOpps[i]);
                        }
                        this.volOppList = tmpVolOpps;
                    }

                    if (typeof this.controls['SURVEY_LIST'] !== 'undefined') {
                        this.controls['SURVEY_LIST'].items = [];
                        if (dataSurveys && this.controls['SIS_ENABLE_ADD_SURVEY_PROMPT'].value) {
                            let items = [];
                            for (let oppId in dataSurveys) {
                                if (oppId === 'length') continue;
                                for (let sId in dataSurveys[oppId]) {
                                    if (sId === 'length') continue;
                                    let survey = {};
                                    survey.OPPORTUNITY_ID = oppId;
                                    survey.SURVEY_ID = sId;
                                    survey.value = sId;
                                    survey.TITLE = dataSurveys[oppId][sId];
                                    survey.text = dataSurveys[oppId][sId];
                                    items.push(survey);
                                }
                            }
                            this.controls['SURVEY_LIST'].items = items;
                        }
                    }
                    if (dataFields.VOL_SIGNED_IN === "Yes") {
                        let note = "Sign out of the " + (dataFields.VOL_SIGNIN_SLOT !== "" ? "shift" : "opportunity") + " " + dataFields.VOL_SIGNIN_OPP + ".";
                        this.controls["INFO"].value = note;
                        this.controls["SIGNED_IN"].value = true;
                    } else {
                        let note = this.controls["SELECT_OPP_FOR_SIGNIN_MESSAGE"].value;
                        if (tmpVolSlots.length) {
                            note = this.controls["SELECT_SHIFT_FOR_SIGNIN_MESSAGE"].value;
                        } else if (!tmpVolOpps.length) {
                            note = "Sorry, we are unable to sign you in at this time.";
                        }
                        this.controls["INFO"].value = note;
                    }
                }
            }
        },
        localLog(log, isError) {
            if (typeof THE_CUSTOMER !== 'undefined' && (THE_CUSTOMER === 'CHOC' || THE_CUSTOMER === 'LPCHS' || THE_CUSTOMER === 'MHHS')) {
                if (typeof log !== 'string') {
                    try {
                        log = JSON.stringify(log);
                    } catch (e) {
                        log = '';
                    }
                }
                isError = false;
                let logType = isError ? 3 : -1;
                this.sDs.post('sds_handleJsError', log, '', logType, "Volunteer " + this.volunteerId + " is not signed in");
            }
        },
        localErrorCaptured(tmpError) {
            library.hideLoadingIndicator(this.cId + '_signInOutWrapper');
            this.signInCancel();
            this.signOutCancel();
            this.controls["ERROR"].value = tmpError?.error?.join(" ") || 'Network Error, please try again later.';
            this.controls["INFO"].value = '';
        },
        signIn: async function (event, controlConfig, clickParams) {
            this.stopGoToLoginTimeout();
            this.localLog('signin button clicked');
            if (typeof window?.navigator?.userAgent !== 'undefined') this.localLog(window.navigator.userAgent);
            this.signInButtonClicked = true;
            let opp = clickParams;
            let stationId = this.stationId;
            let volunteerId = this.volunteerId;
            let groupSize = parseInt(opp.group_size, 10) || 1;
            let note = "";
            let opportunityId;
            let slotId;
            if (opp.ID) {
                opportunityId = opp.ID;
                slotId = false;
                note = opp.OPP_SIGNIN_NOTE;
            } else {
                opportunityId = opp.OPPORTUNITY_ID;
                slotId = opp.SCHEDULE_SLOT_ID;
                note = opp.SS_NOTE;
            }
            // show survey
            if (
                volunteerId
                && opportunityId
                && parseInt(this.controls['SIS_ENABLE_ADD_SURVEY_PROMPT'].value, 10) === 1
                && typeof this.controls['SURVEY_LIST'] !== 'undefined'
                && this.controls['SURVEY_LIST'].items.length
            ) {
                let surveysItems = [];
                let additionalSurvey = false;
                for (let i in this.controls['SURVEY_LIST'].items) {
                    if (i === 'length') continue;
                    if (parseInt(this.controls['SURVEY_LIST'].items[i].OPPORTUNITY_ID, 10) === parseInt(opportunityId, 10)) {
                        additionalSurvey = true;
                        surveysItems.push(this.controls['SURVEY_LIST'].items[i]);
                    }
                }
                if (additionalSurvey && surveysItems.length) {
                    let params = {
                        recordId: volunteerId,
                        oppID: opportunityId,
                        slotID: slotId,
                        surveyList: surveysItems,
                        stationID: this.stationId,
                        useRecruiter: true,
                        hideTitle: true,
                        closeAfterSeconds: this.controls['SIS_SURVEY_MSG_TIMEOUT_DELAY'].value
                    };
                    let response = await actionStore.openSurvey(params);
                    this.signInButtonClicked = false;
                    if (response && response.dialogResponse && response.dialogResponse.status === 'success') {
                        this.goToLogin();
                        /* this.showBackButtonInsteadOfUndo = true;
                        let waitSeconds = parseInt(this.controls["SIS_IN_TIMEOUT"].value, 10) || 0;
                        if (timeouts['signInTimeout']) {
                            clearTimeout(timeouts['signInTimeout']);
                            timeouts['signInTimeout'] = 0;
                        }
                        this.controls["ACTION_CANCELED"].value = false;
                        this.controls["ERROR"].value = '';
                        if (!note) {
                            note = this.controls["SIGNIN_COMPLETE_MESSAGE"].value;
                        }
                        this.controls["SUCCESS"].value = note;
                        this.setSecondsOfWaiting(waitSeconds);
                        timeouts['signInTimeout'] = setTimeout(() => { this.showBackButtonInsteadOfUndo = false; this.goToLogin(); }, waitSeconds * 1000); // NOSONAR */
                    }
                    this.startGoToLoginTimeout();
                    return;
                }
            }
            // show survey end
            if (stationId && volunteerId && opportunityId) {
                let waitSeconds = parseInt(this.controls["SIS_IN_TIMEOUT"].value, 10) || 0;
                this.localLog('waitSeconds' + waitSeconds);
                this.controls["ACTION_CANCELED"].value = false;
                this.controls["ERROR"].value = '';
                if (!note) {
                    note = this.controls["SIGNIN_COMPLETE_MESSAGE"].value;
                }
                this.controls["SUCCESS"].value = note;
                library.showLoadingIndicator(this.cId + '_signInOutWrapper');
                this.localLog('signin start');
                this.sDs.post("er_SISSignIn", stationId, volunteerId, opportunityId, slotId, groupSize, this.signinStore.isGuest).then((response) => {
                    library.hideLoadingIndicator(this.cId + '_signInOutWrapper');
                    this.localLog('signin end');
                    this.startGoToLoginTimeout();
                    this.signInButtonClicked = false;
                    if (response.status === 'success') {
                        this.localLog('signin end success');
                        this.setSecondsOfWaiting(waitSeconds);
                        setTimeout(() => {
                            this.setSecondsOfWaiting(0);
                            this.goToLogin();
                        }, waitSeconds * 1000); // NOSONAR
                    } else {
                        this.signInCancel();
                        this.localLog('signin end fail');
                        this.localLog(response, true);
                        this.localErrorCaptured(response);
                    }
                });
            } else {
                let errorMsg = "\nstationId: " + stationId;
                errorMsg += "\nvolunteerId: " + volunteerId;
                errorMsg += "\nopportunityId: " + opportunityId;
                errorMsg += "\nUser actions: " + JSON.stringify(this.userActions);
                this.sDs.post('sds_handleJsError', errorMsg, '', 3, "Volunteer is not signed in");
            }
        },
        setSecondsOfWaiting(seconds) {
            if (seconds < 0) return;
            this.seconds = seconds;
            if (timeouts['waitingTimeout']) {
                clearTimeout(timeouts['waitingTimeout']);
                timeouts['waitingTimeout'] = 0;
            }
            if (seconds) {
                timeouts['waitingTimeout'] = setTimeout(() => {
                    this.setSecondsOfWaiting(seconds - 1);
                }, 1000);
            }
        },
        afterSurveySubmit: function () {
            this.surveySubmited = true;
        },
        takeSurvey: async function () {
            if (this.showSurvey) {
                this.controls['SURVEY_SIGN_OUT_SURVEY_INFO_MESSAGE'].value = '';
                let surveysItems = library.cloneObj(this.controls['SURVEY_LIST'].items);
                let volunteerId = this.volunteerId;
                let opportunityId = surveysItems[0].OPPORTUNITY_ID;
                let params = {
                    recordId: volunteerId,
                    oppID: opportunityId,
                    lbeID: this.signOutLbe,
                    stationID: this.stationId,
                    surveyList: surveysItems,
                    useRecruiter: true,
                    hideTitle: true,
                    closeAfterSeconds: this.controls['SIS_SURVEY_MSG_TIMEOUT_DELAY'].value
                };
                this.stopGoToLoginTimeout();
                let result = await actionStore.openSurvey(params);
                this.startGoToLoginTimeout();
                if (result && result.dialogResponse && result.dialogResponse.funcPreSuccess && result.dialogResponse.funcPreSuccess.status === 'success') {
                    this.afterSurveySubmit();
                    this.surveySubmited = true;
                    this.controls['SURVEY_SIGN_OUT_SURVEY_INFO_MESSAGE'].value = "Sign out of the " + (this && this.volunteer && this.volunteer.VOL_SIGNIN_SLOT !== "" ? "shift" : "opportunity") + " " + (this && this.volunteer ? this.volunteer.VOL_SIGNIN_OPP : '') + ".";
                }
            }
        },
        signOut: async function () {
            this.stopGoToLoginTimeout();
            let waitSeconds = parseInt(this.controls["SIS_OUT_TIMEOUT"].value, 10) || 0;
            this.controls["ACTION_CANCELED"].value = false;
            this.controls["ERROR"].value = '';
            this.controls["SUCCESS"].value = this.controls["SIGNOUT_COMPLETE_MESSAGE"].value;

            library.showLoadingIndicator(this.cId + '_signInOutWrapper');
            this.sDs.post("er_SISSignOut", this.stationId, this.volunteerId).then((response) => {
                library.hideLoadingIndicator(this.cId + '_signInOutWrapper');
                this.startGoToLoginTimeout();
                if (response.status === 'success') {
                    this.setSecondsOfWaiting(waitSeconds);
                    setTimeout(() => {
                        this.setSecondsOfWaiting(0);
                        this.goToLogin();
                    }, waitSeconds * 1000); // NOSONAR
                } else if (typeof response.error !== 'undefined') {
                    this.signOutCancel();
                    this.signOutError = true;
                    this.controls["ERROR"].value = response.error.join(" ");
                }
            });
        },
        signInCancel: async function () {
            this.signInButtonClicked = false;
            this.setSecondsOfWaiting(0);
            this.controls["ACTION_CANCELED"].value = true;
            this.controls["ERROR"].value = this.controls["SIGNIN_CANCELED_MESSAGE"].value;
            this.controls["INFO"].value = this.controls["VOL_SLOT_LIST"].items.length ? this.controls["SELECT_SHIFT_FOR_SIGNIN_MESSAGE"].value : this.controls["SELECT_OPP_FOR_SIGNIN_MESSAGE"].value;
            this.controls["SUCCESS"].value = "";
        },
        signOutCancel: async function () {
            this.signOutError = false;
            this.setSecondsOfWaiting(0);
            this.controls["ACTION_CANCELED"].value = true;
            this.controls["ERROR"].value = this.controls["SIGNOUT_CANCELED_MESSAGE"].value;
            this.controls["INFO"].value = "Sign out of the " + (this && this.volunteer && this.volunteer.VOL_SIGNIN_SLOT !== "" ? "shift" : "opportunity") + " " + (this && this.volunteer ? this.volunteer.VOL_SIGNIN_OPP : '') + ".";
            this.controls["SUCCESS"].value = "";
        },
        showGroupSize: function (event, controlConfig, clickParams) {
            let tmpSlotList = library.cloneObj(this.volSlotList);
            tmpSlotList[clickParams.key].show_group_size = true;
            this.volSlotList = tmpSlotList;
            this.controls["GROUP_SIZE__" + clickParams.key].value = clickParams.group_size;
        },
        changeGroupSize: function (event, controlConfig, changeParams) {
            let tmpSlotList = library.cloneObj(this.volSlotList);
            tmpSlotList[changeParams.key].group_size = controlConfig.value;
            this.volSlotList = tmpSlotList;
            this.controls["SIGN_IN_BUTTON__" + changeParams.key].label = controlConfig.value > 1 ? 'Sign In with ' + controlConfig.value : 'Sign In';
        },
    },
    components: {
        'messagePanel': messagePanel
    },
    unmounted: function () {
        this.removeHandlers();
        this.clearTimeouts();
    }
};

componentStore.initComponent(signInOutCmp, signInOutConfig, '@signin/signInOut.vue');
export { signInOutConfig, signInOutCmp };
export default signInOutCmp;

</script>

<style scoped>
:deep(.e-control *) {
    font-size: 18px !important;
}

:deep(.date-time) {
    font-family: 'Syncopate',sans-serif;
    font-size: 2.5em;
    margin: 0;
    text-align: center;
    width: 100%;
    display: block;
}

:deep([id^="SIS_NAME"] *) {
    color: #337ab7;
    font-weight: bold;
    font-size: 2.3em !important;
    line-height: 1em;
}

:deep([id^="VOL_LAST_NAME"] *) {
    font-weight: bold;
}

:deep([id^="VOL_FIRST_NAME"] *) {
    font-weight: bold;
}

:deep(.inline-block) {
    display: inline-block;
    margin: 2px 0px;
}

:deep(.e-back) {
    color: #337ab7 !important;
    background-color: #fff !important;
    border-color: #fff !important;
}

:deep(.sis-logo) {
    width: 360px;
    margin: 0 auto;
    display: block;
}

:deep([name="VOL_SLOT_LIST"] [id^="element_"]) {
    min-height: 90px;
}

:deep([name="VOL_OPPORTUNITY_LIST"] [id^="element_"]) {
    min-height: 90px;
}
:deep(.e-yellow) {
    background-color: #fdd877;
    color: black;
}

:deep(.signin-css .e-btn.e-danger[disabled]),
:deep(.signin-css .v-application .v-btn.error[disabled]) {
    color: #949494 !important;
}

:deep(.ready-to-signout-message) {
    position: relative;
}
:deep(.ready-to-signout-message > div) {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    top: -1.7em;
    color: #337ab7;
    font-size: 1.7em !important;
    background: white;
    width: fit-content;
    block-size: fit-content;
}
</style>
